/**
 * Footer component
 * @returns {React.ReactElement} JSX.Element - the Footer component
 */

function Header() {
  return (
    <footer className="footer text-center my-4">
      <p className="footer-text">Copyright 2022 RHnet</p>
    </footer>
  )
}

export default Header
